import { Dialog, DialogBody, DialogTitle, EditProps } from '@/components/base/dialog'
import { EditMaintenanceTypesQuery } from './__generated__/edit_query'
import { Query } from './edit_query'
import { Form as DetailsForm } from './edit_form'
import { useQuery } from '@apollo/client'
import { Inline as Loading } from '@/components/loading'
import { ClipboardDocumentIcon, PencilIcon } from '@heroicons/react/24/solid'
import { Tabs } from '../tabs'
import { Form as EditMaintenanceTask } from './edit_maintenance_task'

export const EditDialog = ({ id, open, setOpen }: EditProps) => {
  const tabs = [
    { name: 'Details', component: <DetailsForm id={id} onSuccess={() => setOpen(false)} />, icon: PencilIcon },
    { name: 'Tasks', component: <EditMaintenanceTask id={id} />, icon: ClipboardDocumentIcon }
  ]

  const { data, loading } = useQuery<EditMaintenanceTypesQuery>(Query, { variables: { filters: { idEq: id } } })

  return (
    <>
      <Dialog open={open} size="5xl" onClose={setOpen}>
        <DialogTitle>
          <div>
            { loading || !data ? <Loading /> : data.maintenanceTypes.nodes[0].name }
          </div>
        </DialogTitle>
        <DialogBody>
          <Tabs tabs={tabs} />
        </DialogBody>
      </Dialog>
    </>
  )
}
